export const ComandosDoSchedule = {
  propostasResumida: 'sync:sincronizacao_propostas --resumida=true'
}

export function LogPurgeManualScheduleCommand (days) {
  if (days < 0) {
    days = 0
  }

  return `expurgo:logs --tempo_manual=${days}`
}
